import { useAuiState } from "@assistant-ui/react";
import React from "react";
import { FormattedMessage } from "react-intl";
import styles from "./ThinkingIndicator.scss";

const msgKey = "aiChatMessages";

// A turn counts as "thinking" while it is running and nothing answer-like is
// visible yet: the submitted phase, reasoning-only content, and tool phases
// all keep the indicator up until real text arrives.
const lastMessageHasVisibleText = (messages) => {
    const last = messages[messages.length - 1];
    return (
        last?.role === "assistant" &&
        !!last.content?.some((part) => part.type === "text" && part.text?.trim().length > 0)
    );
};

export const ThinkingIndicator = () => {
    const showThinking = useAuiState(
        (state) => state.thread.isRunning && !lastMessageHasVisibleText(state.thread.messages)
    );

    if (!showThinking) {
        return null;
    }

    return (
        <div className={styles.base} role="status" aria-live="polite">
            <span className={styles.dots} aria-hidden="true">
                <span className={styles.dot} />
                <span className={styles.dot} />
                <span className={styles.dot} />
            </span>
            <span className={styles.label}>
                <FormattedMessage id={`${msgKey}.thinking`} />
            </span>
        </div>
    );
};
